import React, { Fragment, useEffect } from 'react';
import { Router } from 'react-router-dom';
import Routes from './components/routing/Routes';
import history from './History';


import { Provider } from 'react-redux';
import store from './store';
import { loadUser } from './actions/auth';
import setAuthToken from './utils/setAuthToken';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './App.css';


if(localStorage.token){
  setAuthToken(localStorage.token);
}



const App = () => {
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  let deferredPrompt;

window.addEventListener('beforeinstallprompt', (e) => {
    deferredPrompt = e;
});

const installApp = document.getElementById('installApp');

installApp.addEventListener('click', async () => {
    if (deferredPrompt !== null) {
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
            deferredPrompt = null;
        }
    }
});

return(
  <Provider store={store}>
    <Router history={history}>
      <Fragment>
        <ToastContainer
          position="bottom-right"
          autoClose={5001}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          className= "noprint"
        />
        <Routes component={Routes} />
      </Fragment>
    </Router>
  </Provider>
)};


export default App;
